import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SecureLayoutComponent } from "./layout/layout.component";
import { authGuard } from "../_guards/authenticated.guard";

const routes: Routes = [
  {
    path: "",
    component: SecureLayoutComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then(m => m.DashboardModule),
      },
      {
        path: "jobs/overview",
        loadChildren: () =>
          import("./_jobs/jobs-overview/jobs-overview.module").then(
            m => m.JobsOverviewModule
          ),
      },
      {
        path: "jobs/payments",
        loadChildren: () =>
          import(
            "./_jobs/jobs-payment-overview/jobs-payment-overview.module"
          ).then(m => m.JobsPaymentOverviewModule),
      },
      {
        path: "jobs/detail",
        loadChildren: () =>
          import("./_jobs/job-dashboard/job-dashboard.module").then(
            m => m.JobDashboardModule
          ),
      },
      {
        path: "orders/overview",
        loadChildren: () =>
          import(
            "./_orders/open-orders-overview/open-orders-overview.module"
          ).then(m => m.OpenOrdersOverviewModule),
      },
      {
        path: "orders/detail",
        loadChildren: () =>
          import("./_orders/order-detail/order-detail.module").then(
            m => m.OrderDetailModule
          ),
      },
      {
        path: "payments/history",
        loadChildren: () =>
          import(
            "./_payments/payment-history-overview/payment-history-overview.module"
          ).then(m => m.PaymentHistoryOverviewModule),
      },
      {
        path: "payments/detail",
        loadChildren: () =>
          import("./_payments/payment-detail/payment-detail.module").then(
            m => m.PaymentDetailModule
          ),
      },
      {
        path: "invoices/unpaid",
        loadChildren: () =>
          import(
            "./_invoices/unpaid-invoices-overview/unpaid-invoice-overview.module"
          ).then(m => m.UnpaidInvoiceOverviewModule),
      },
      {
        path: "invoices/payments",
        loadChildren: () =>
          import(
            "./_invoices/invoice-payment-overview/invoice-payment-overview.module"
          ).then(m => m.InvoicePaymentOverviewModule),
      },
      {
        path: "invoices/detail",
        loadChildren: () =>
          import("./_invoices/invoice-detail/invoice-detail.module").then(
            m => m.InvoiceDetailModule
          ),
      },
      {
        path: "invoices/history",
        loadChildren: () =>
          import(
            "./_invoices/invoice-history-overview/invoice-history-overview.module"
          ).then(m => m.InvoiceHistoryOverviewModule),
      },
      {
        path: "invoices/download",
        loadChildren: () =>
          import(
            "./_invoices/invoice-download-overview/invoice-download-overview.module"
          ).then(m => m.InvoiceDownloadOverviewModule),
      },
      {
        path: "whats-new",
        loadChildren: () =>
          import("./whats-new/whats-new.module").then(m => m.WhatsNewModule),
      },
      {
        path: "my-account",
        loadChildren: () =>
          import("./my-account/my-account.module").then(m => m.MyAccountModule),
      },
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "**",
        redirectTo: "dashboard",
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SecureRoutingModule {}
